import React, { Component } from 'react'
import {  Link } from "react-router-dom"
import PropTypes from 'prop-types'

import SJDigVerifyFormBusCom from './SJDigVerify'
//import SJReservationConfirmationCodeFormBusCom from './SJReservationDetail'
import SJPBPaymentDetailFormBusCom from './SJPBPaymentDetail'
//import SJPaymentDetailFormBusCom from './SJPaymentDetail'
import SJPBPaymentCardFormBusCom from './SJPBCardDetail'
import SJReservationConfirmationCodeFormBusCom from './SJReservationDetail'

import history from '../../history'
import SuccessCom from '../core/AbodeSuccessTag'
import ErrorCom from '../core/AbodeErrorTag'
import SVAbodeSpinner from '../core/SVAbodeSpinner'

import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';


class WizardPBForm extends Component {
  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.state = {
      page: 1
    }
    //aug28 start
    this.closecbParent = this.closecbParent.bind(this)
    this.closecbParentSuccess = this.closecbParentSuccess.bind(this)
        

    //aug28 end..
  }
  //aug28 start
  closecbParentSuccess(){
    let svCustomerId = -2
    const {custProfile} = this.props
    svCustomerId = custProfile ? custProfile.customerId: -3
    
    console.log('a29 closecbParentSuccess svCustomerId*********')
    console.log(svCustomerId)
    history.push(`/myreservationsSV/${svCustomerId}`)

  }
  closecbParent(){
    let svCustomerId = -2
    const {custProfile} = this.props
    svCustomerId = custProfile ? custProfile.customerId: -3
    
    console.log('a29 closecbParentSuccess svCustomerId*********')
    console.log(svCustomerId)
    history.push(`/myreservationsSV/${svCustomerId}`)
  }
  //aug28 end
  svsubmitparentReview(values){
    let me = this
  console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
  console.log(values)
  ///essearch/spaceBookNow
 //return this.props.bookNow(values)
/*
  const pr =  new Promise(resolve => {
    setTimeout(() => {
      // simulate server latency
      console.log(`You submitted:\n\n${JSON.stringify(values, null, 2)}`)
      //window.alert(`You submitted:\n\n${JSON.stringify(values, null, 2)}`)
      resolve()
    }, 500)
  })

  return pr;
  */
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}

  nextPage(values) {
      console.log('**form ***** values ')
      console.log(values)
      console.log('***page' + this.state.page)
      if(this.state.page ==1){
        this.setState({ page: this.state.page + 1 , svcusinfo:values})

      }else if(this.state.page ==2){
          
        this.setState({ page: this.state.page + 1 , svbookform:values})
        this.props.svguestsaveparent(values)
      }else if(this.state.page ==3){
        this.setState({ page: this.state.page + 1 , sjreviewview:values})
        this.props.svsubmitparent(values)
    }else if(this.state.page ==4){
        this.setState({ page: this.state.page + 1 , svconfirmcodeform:values})
    
     

      }else{
        this.setState({ page: this.state.page + 1 })
      }
   
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 })
  }

  render() {
      console.log('sv a29 ****IMP*** sjpbwizard propts******* ')
      console.log(this.props)
      console.log('%%%%%%%%%%%%sv*********wizard needs custpProfile', this.props.custProfile)
    const { onSubmit, svsubmitparent, svrcsubmitparent, custProfile } = this.props
    
    const { page } = this.state
    //svaug28
    let hasErrorOrSuccess = false
    let svCustomerId = -2
   
    svCustomerId = custProfile ? custProfile.customerId: -3

    const {errob, crudsuccessob} = this.props
    if(this.props.errorRESERVATION){
      if(errob && (errob.status > 0 ) && (errob.message.length > 0 )){
        hasErrorOrSuccess = true
      }
      if(crudsuccessob && (crudsuccessob.status ==  200 ) && (crudsuccessob.message.length > 0 )){
        hasErrorOrSuccess = true
      }
    }

    if(this.props.errorRESERVATION  && ( hasErrorOrSuccess == true )){
      console.log('sv**container ger errob')
      console.log(this.props)
      if(crudsuccessob &&  (crudsuccessob.status == 200)){

       console.log('sv** a29***container ger crudsuccessob')
       return(
         <div >
             
           <div style={{paddingTop:'10px'}}>
             <SuccessCom  svCustomerId={svCustomerId} closecbParentSuccess={this.closecbParentSuccess} crudsuccessob={this.props.crudsuccessob} ></SuccessCom>
           </div>
           <div style={{paddingTop:'10px'}}>
               <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myreservationsSV/9`}> My Reservations List   </Link></SVAButton>
           </div>
       
         </div>   
         
       )

      }

      if(errob &&  (errob.status != 200)){
         return (
           <div >
             
               <div style={{paddingTop:'10px'}}>
                 <ErrorCom closecbParent={this.closecbParent}  errob={this.props.errob} ></ErrorCom>
               </div>
               <div style={{paddingTop:'10px'}}>
                   <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myreservationsSV/9`}> My Reservations List   </Link></SVAButton>
               </div>
             
           </div>   
             )
     }
    }else if(this.props.loadingRESERVATION ){
     return (

     
       <div >
       <h3>Spinner*****</h3>
      <div style={{paddingTop:'10px'}}>

      <SVAbodeSpinner />
      </div>

   </div>   


     
           )

    }
    
    //svaug28 end
    return (
      <div>
        <h3>Probate Will SJ</h3>
        {page === 1 && <SJDigVerifyFormBusCom sj_data_dtoken = {this.props.sj_data_dtoken}
        custProfile= {this.props.custProfile}
        
        onSubmit={this.nextPage} />}
        {page === 2 && (
          <SJPBPaymentDetailFormBusCom
            sj_data_address = {this.props.sj_data_address}
            my_data_geo = {this.props.my_data_geo}
            custProfile= {this.props.custProfile}
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
          />
        )}
        {page === 3 && (
          <SJPBPaymentCardFormBusCom
          {...this.props}
          sj_data_card = {this.props.sj_data_card}
          my_data_testator = {this.props.my_data_testator}

         
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
          />
        )}
         {page === 4 && (
          <SJReservationConfirmationCodeFormBusCom
          {...this.props}
            previousPage={this.previousPage}
            onSubmit={svrcsubmitparent}
          />
        )}
      </div>
    )
  }

}
WizardPBForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
}

export default WizardPBForm
